import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

var StructuredData = function StructuredData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
    // We must use dangerous as we don't want things HTML
    // entity encoded. Like `"` would be `&quot;`
    // eslint-disable-next-line zillow/react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(data)
    }
  }));
};
StructuredData.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.shape({})
} : {};
var StructuredData$1 = StructuredData;

export { StructuredData$1 as default };
